export default "__VITE_PUBLIC_ASSET__437e0c47__"